module.exports = "./c57262807b0478f3dd08a24eefb47d21.png";